export const CoordLetter = {
  text: "We are Iris Rivera, Banesa Valencia, and Sawyer Rudy, collectively known as Team I.B.S, and we are your 2026 DINO-Week Coordinators!\n\n As O-Week Coordinators, it’s our job to make sure that your hatching into college goes as smoothly as it possibly can, and that all of you incoming Jonesians are given the best opportunity to dino-soar. In just a week, we will introduce you to the many resources at Jones and Rice that are established to ensure that each and every one of you has the tools to succeed and leave your claw-prints on our community. We know it can be scary; we were in your shoes less than 2 years ago, but it is not veloci-rapture. We will be here to support you every step of the way. Rice's Orientation-Week, otherwise known as “O-Week”, is unique and distinguished from orientation programs at other universities. Broadly, events in O-Week can be divided into three ways: events that help you plan your classes and prepare for them, events that describe the resources you have at Rice and beyond, and events that help you get to know the family of Jones and of Rice! And if you’re worried about bringing anything or being prepared for any of this, don’t worry – this book, and the people around you during this exciting week, will help you to know exactly what to bring, and what to expect at any given moment. It’s okay if you don’t have everything figured out right now—what classes to take, what clubs to join, or where you want to end up after graduation. As your Coords and part of your O-Week Team, we’ll guide your tracks through the Mesozoic jungle of college. \n\n The very first people you’ll meet during O-Week will be your Advisors, a hand-picked, diverse, engaged, and trained group of upperclassmen who volunteer part of their summer to learn how to best introduce you to Jones. Every freshman is paired with 4-5 Advisors and 8-10 other freshmen, who all together form an “O-Week Family”. This group is not only a major part of your O-Week, but also your whole first year – you’ll check in on each other, share meals weekly, and find the answers to any questions you may have. As the saying here at Rice goes, O-Week is forever.\n\n All throughout your new nest at Jones, you will encounter every species of dinosaur, with each bringing its own set of strengths and shortcomings. Despite these variations, you will find that any and every one of your fellow Jonesians will always be there to protect their hatch. It is for this reason that we chose DinO-Week to be our Jones O-Week 2026 Theme. No two people hatch into Jones the same; some of our hatchlings may fly, some may swim, some may have feathers, and some may have spikes, but we are undeniably exuberant to welcome all regardless. College will undeniably send some meteors in your direction, but fret not, we will be there to support every step of the way. \n\n You probably have a lot of questions going into O-Week, but never fear. No matter what happens, the three of us and the rest of your nest will always be here to help. Don’t be afraid to reach out with any concerns. \n\n We can’t wait to welcome you with open arms!",
  coordInfo: [
    {
      name: "Iris Rivera",
      phone: "ir32@rice.edu",
    },
    {
      name: "Banesa Valencia ",
      phone: "bv23@rice.edu",
    },
    {
      name: "Sawyer Rudy",
      phone: "sr168@rice.edu",
    },
  ],
  email: "marygibbsjonesoweek@gmail.com",
};

export const CoordBios = [
  {
    name: "IRIS RIVERA",
    bio: "Iris is a junior from Austin, TX studying Psychology. Outside of academics, she loves listening to music, taking walks, thrifting, frequenting the Jitchen late at night, and rotting on TikTok. ",
    img: "./images/oweek/coords/Iris.JPG",
  },
  {
    name: "BANESA VALENCIA",
    bio: "Banesa is a junior from Ridgeland, Ms studying Mathematics and English on the Creative writing track. She is known for her insane sudoku stats, making friendship bracelets in the 1N lobby, and working at the RMC info desk.",
    img: "./images/oweek/coords/Banesa.JPG",
  },
  {
    name: "SAWYER RUDY",
    bio: "Sawyer is a Sophmore from Chandler, Arizona studying Chemical Engineering with aspirations of going to medical school. He is known for working various jobs in the RMC, frequenting the North laundry room and 3N table, and bringing an overall sense of whimsy.",
    img: "./images/oweek/coords/Sawyer.JPG",
  },
];
export const OWeekGroups = [
  {
    name: "LaLaLand Before Time",
    members: "Charlie Wei, David Uchime, Nancy Martinez",
    img: "./images/oweek/oweek-groups/Group 1_ LaLaLand Before Time/La La Land Before Time.png",
    profiles: [
      {
        name: "Charlie Wei",
        email: "",
        major: "",
        collegetag: "./college-tags/jones_tag.png",
        img: "./images/oweek/oweek-groups/Group 1_ LaLaLand Before Time/Charlie Wei_LaLaLand Before Time.jpg",
      },
      {
        name: "David Uchime",
        email: "",
        major: "",
        collegetag: "./college-tags/jones_tag.png",
        img: "./images/oweek/oweek-groups/Group 1_ LaLaLand Before Time/David Uchime_LaLaLand Before Time.jpg",
      },
      {
        name: "Nancy Martinez",
        email: "",
        major: "",
        collegetag: "./college-tags/jones_tag.png",
        img: "./images/oweek/oweek-groups/Group 1_ LaLaLand Before Time/Nancy Martinez_LaLaLand Before Time.jpg",
      },
    ],
  },
  {
    name: "The Dino Wears Prada",
    members: "Anya Ruttala, Craig Pentland, Hannah Guo, Ryan Olatunji",
    img: "./images/oweek/oweek-groups/Group 2_ The Dino Wears Prada/The Dino Wears Prada.png",
    profiles: [
      {
        name: "Anya Ruttala",
        email: "",
        major: "",
        collegetag: "./college-tags/jones_tag.png",
        img: "./images/oweek/oweek-groups/Group 2_ The Dino Wears Prada/Anya Ruttala_The Dino Wears Prada.JPG",
      },
      {
        name: "Craig Pentland",
        email: "",
        major: "",
        collegetag: "./college-tags/jones_tag.png",
        img: "./images/oweek/oweek-groups/Group 2_ The Dino Wears Prada/Craig Pentland_The Dino Wears Prada.jpg",
      },
      {
        name: "Hannah Guo",
        email: "",
        major: "",
        collegetag: "./college-tags/jones_tag.png",
        img: "./images/oweek/oweek-groups/Group 2_ The Dino Wears Prada/Hannah Guo_The Dino Wears Prada.JPG",
      },
      {
        name: "Ryan Olatunji",
        email: "",
        major: "",
        collegetag: "./college-tags/jones_tag.png",
        img: "./images/oweek/oweek-groups/Group 2_ The Dino Wears Prada/Ryan Olatunji_The Dino Wears Prada.JPG",
      },
    ],
  },
  {
    name: "Tyler the Crater: Call Me If You Get Rocked",
    members: "Alyse Tran, Ben Lindenbaum, Lily Hestjean, Marco Cancio",
    img: "./images/oweek/oweek-groups/Group 3_ Tyler the Crater_ Call Me If You Get Rocked/Tyler the Crater Call Me If You Get Rocked.png",
    profiles: [
      {
        name: "Alyse Tran",
        email: "",
        major: "",
        collegetag: "./college-tags/jones_tag.png",
        img: "./images/oweek/oweek-groups/Group 3_ Tyler the Crater_ Call Me If You Get Rocked/Alyse Tran_Tyler the Crater.jpg",
      },
      {
        name: "Ben Lindenbaum",
        email: "",
        major: "",
        collegetag: "./college-tags/jones_tag.png",
        img: "./images/oweek/oweek-groups/Group 3_ Tyler the Crater_ Call Me If You Get Rocked/Ben Lindenbaum_Tyler the Crater.png",
      },
      {
        name: "Lily Hestjean",
        email: "",
        major: "",
        collegetag: "./college-tags/jones_tag.png",
        img: "./images/oweek/oweek-groups/Group 3_ Tyler the Crater_ Call Me If You Get Rocked/Lily Hestjean_Tyler the Crater.jpg",
      },
      {
        name: "Marco Cancio",
        email: "",
        major: "",
        collegetag: "./college-tags/jones_tag.png",
        img: "./images/oweek/oweek-groups/Group 3_ Tyler the Crater_ Call Me If You Get Rocked/Marco Cancio_Tyler the Crater.jpg",
      },
    ],
  },
  {
    name: "How I Met Your Meteor",
    members:
      "Anthony Valente, Dylan Yoon, Helen Cintino, Jasper Yuan, Julia Mickiewicz",
    img: "./images/oweek/oweek-groups/Group 4_ How I Met Your Meteor/How I Met Your Meteor.png",
    profiles: [
      {
        name: "Anthony Valente",
        email: "",
        major: "",
        collegetag: "./college-tags/jones_tag.png",
        img: "./images/oweek/oweek-groups/Group 4_ How I Met Your Meteor/Anthony Valente_How I Met Your Meteor.JPG",
      },
      {
        name: "Dylan Yoon",
        email: "",
        major: "",
        collegetag: "./college-tags/jones_tag.png",
        img: "./images/oweek/oweek-groups/Group 4_ How I Met Your Meteor/Dylan Yoon_How I Met Your Meteor.jpg",
      },
      {
        name: "Helen Cintino",
        email: "",
        major: "",
        collegetag: "./college-tags/jones_tag.png",
        img: "./images/oweek/oweek-groups/Group 4_ How I Met Your Meteor/Helen Cintino_How I Met Your Meteor.png",
      },
      {
        name: "Jasper Yuan",
        email: "",
        major: "",
        collegetag: "./college-tags/jones_tag.png",
        img: "./images/oweek/oweek-groups/Group 4_ How I Met Your Meteor/Jasper Yuan_How I Met Your Meteor.jpg",
      },
      {
        name: "Julia Mickiewicz",
        email: "",
        major: "",
        collegetag: "./college-tags/jones_tag.png",
        img: "./images/oweek/oweek-groups/Group 4_ How I Met Your Meteor/Julia Mickiewicz_How I Met Your Meteor.png",
      },
    ],
  },
  {
    name: "K-pop Dino Hunters",
    members: "Abigail Li, Leslie Rojo Flores, Lisa Wang, Ryan Duan",
    img: "./images/oweek/oweek-groups/Group 5_ K-pop Dino Hunters/K-Pop Dino Hunters.png",
    profiles: [
      {
        name: "Abigail Li",
        email: "",
        major: "",
        collegetag: "./college-tags/jones_tag.png",
        img: "./images/oweek/oweek-groups/Group 5_ K-pop Dino Hunters/Abigail Li_K-Pop Dino Hunters.jpg",
      },
      {
        name: "Leslie Rojo Flores",
        email: "",
        major: "",
        collegetag: "./college-tags/jones_tag.png",
        img: "./images/oweek/oweek-groups/Group 5_ K-pop Dino Hunters/Leslie Rojo Flores_K-Pop Dino Hunters.jpg",
      },
      {
        name: "Lisa Wang",
        email: "",
        major: "",
        collegetag: "./college-tags/jones_tag.png",
        img: "./images/oweek/oweek-groups/Group 5_ K-pop Dino Hunters/Lisa Wang_K-Pop Dino Hunters.jpg",
      },
      {
        name: "Ryan Duan",
        email: "",
        major: "",
        collegetag: "./college-tags/jones_tag.png",
        img: "./images/oweek/oweek-groups/Group 5_ K-pop Dino Hunters/Ryan Duan_K-Pop Dino Hunters.jpg",
      },
    ],
  },
  {
    name: "Howl's Moving Raptor",
    members: "Anya Ramnani, Caroline Nguyen, Darren Pai, Jose Eleuterio",
    img: "./images/oweek/oweek-groups/Group 6_ Howl_s Moving Raptor/Howl_s Moving Raptor.png",
    profiles: [
      {
        name: "Anya Ramnani",
        email: "",
        major: "",
        collegetag: "./college-tags/jones_tag.png",
        img: "./images/oweek/oweek-groups/Group 6_ Howl_s Moving Raptor/Anya Ramnani_Howl_s Moving Raptor.jpg",
      },
      {
        name: "Caroline Nguyen",
        email: "",
        major: "",
        collegetag: "./college-tags/jones_tag.png",
        img: "./images/oweek/oweek-groups/Group 6_ Howl_s Moving Raptor/Caroline Nguyen_Howl_s Moving Raptor.jpg",
      },
      {
        name: "Darren Pai",
        email: "",
        major: "",
        collegetag: "./college-tags/jones_tag.png",
        img: "./images/oweek/oweek-groups/Group 6_ Howl_s Moving Raptor/Darren Pai_Howl_s Moving Raptor.jpg",
      },
      {
        name: "Jose Eleuterio",
        email: "",
        major: "",
        collegetag: "./college-tags/jones_tag.png",
        img: "./images/oweek/oweek-groups/Group 6_ Howl_s Moving Raptor/Jose Eleuterio_Howl_s Moving Raptor.jpg",
      },
    ],
  },
  {
    name: "Star Rawrs: The Fossil Awakens",
    members: "Dyllan Lozano-Lomeli, Kevwe Ikeneku, Poema Sumrow, Ryan Ji",
    img: "./images/oweek/oweek-groups/Group 7_ Star Rawrs_ The Fossil Awakens/Star Rawrs The Fossil Awakens.png",
    profiles: [
      {
        name: "Dyllan Lozano-Lomeli",
        email: "",
        major: "",
        collegetag: "./college-tags/jones_tag.png",
        img: "./images/oweek/oweek-groups/Group 7_ Star Rawrs_ The Fossil Awakens/Dyllan Lozano-Lomeli_Star Rawrs.jpg",
      },
      {
        name: "Kevwe Ikeneku",
        email: "",
        major: "",
        collegetag: "./college-tags/jones_tag.png",
        img: "./images/oweek/oweek-groups/Group 7_ Star Rawrs_ The Fossil Awakens/Kevwe Ikeneku_Star Rawrs.jpg",
      },
      {
        name: "Poema Sumrow",
        email: "",
        major: "",
        collegetag: "./college-tags/jones_tag.png",
        img: "./images/oweek/oweek-groups/Group 7_ Star Rawrs_ The Fossil Awakens/Poema_Sumrow_Star Rawrs.png",
      },
      {
        name: "Ryan Ji",
        email: "",
        major: "",
        collegetag: "./college-tags/jones_tag.png",
        img: "./images/oweek/oweek-groups/Group 7_ Star Rawrs_ The Fossil Awakens/Ryan Ji_Star Rawrs.jpg",
      },
    ],
  },
  {
    name: "Game of Bones: House of the Dino",
    members:
      "Daniel Merklen Pimenta de Medeiros, Sam Forman, Sofia Tambalotti, Zoë Marquez",
    img: "./images/oweek/oweek-groups/Group 8_ Game of Bones_ House of the Dino/Game of Bones House Of The Dino.png",
    profiles: [
      {
        name: "Daniel Merklen Pimenta de Medeiros",
        email: "",
        major: "",
        collegetag: "./college-tags/jones_tag.png",
        img: "./images/oweek/oweek-groups/Group 8_ Game of Bones_ House of the Dino/Daniel Merklen Pimenta de Medeiros_Game of Bones.jpg",
      },
      {
        name: "Sam Forman",
        email: "",
        major: "",
        collegetag: "./college-tags/jones_tag.png",
        img: "./images/oweek/oweek-groups/Group 8_ Game of Bones_ House of the Dino/Sam Forman_Game of Bones House of the Dino.png",
      },
      {
        name: "Sofia Tambalotti",
        email: "",
        major: "",
        collegetag: "./college-tags/jones_tag.png",
        img: "./images/oweek/oweek-groups/Group 8_ Game of Bones_ House of the Dino/Sofia Tambalotti_Game of Bones.jpg",
      },
      {
        name: "Zoë Marquez",
        email: "",
        major: "",
        collegetag: "./college-tags/jones_tag.png",
        img: "./images/oweek/oweek-groups/Group 8_ Game of Bones_ House of the Dino/Zoë Marquez_Game of Bones.jpg",
      },
    ],
  },
  {
    name: "The FlintJones: Great Jibasaur Adventure",
    members: "Akina Damanik, Bella Zhang, Lula Lo, Navya Dronamrjaru",
    img: "./images/oweek/oweek-groups/Group 9_ The FlintJones_ Great Jibasaur Adventure/The FlintJones_ Great Jibasaur Adventure.png",
    profiles: [
      {
        name: "Akina Damanik",
        email: "",
        major: "",
        collegetag: "./college-tags/jones_tag.png",
        img: "./images/oweek/oweek-groups/Group 9_ The FlintJones_ Great Jibasaur Adventure/Akina Damanik_The FlintJones.JPG",
      },
      {
        name: "Bella Zhang",
        email: "",
        major: "",
        collegetag: "./college-tags/jones_tag.png",
        img: "./images/oweek/oweek-groups/Group 9_ The FlintJones_ Great Jibasaur Adventure/Bella Zhang_The FlintJones.JPG",
      },
      {
        name: "Lula Lo",
        email: "",
        major: "",
        collegetag: "./college-tags/jones_tag.png",
        img: "./images/oweek/oweek-groups/Group 9_ The FlintJones_ Great Jibasaur Adventure/Lula Lo_The FlintJones.JPG",
      },
      {
        name: "Navya Dronamrjaru",
        email: "",
        major: "",
        collegetag: "./college-tags/jones_tag.png",
        img: "./images/oweek/oweek-groups/Group 9_ The FlintJones_ Great Jibasaur Adventure/Navya Dronamrjaru_The FlintJones.JPG",
      },
    ],
  },
  {
    name: "Dino Quixote",
    members: "Ben Kwait-Gonchar, Liora Ginsburg, Logan Hobbs, Shuken Nakamura",
    img: "./images/oweek/oweek-groups/Group 10_ Dino Quixote/Dino Quixote.png",
    profiles: [
      {
        name: "Ben Kwait-Gonchar",
        email: "",
        major: "",
        collegetag: "./college-tags/jones_tag.png",
        img: "./images/oweek/oweek-groups/Group 10_ Dino Quixote/Ben Kwait-Gonchar_Dino Quixote.JPG",
      },
      {
        name: "Liora Ginsburg",
        email: "",
        major: "",
        collegetag: "./college-tags/jones_tag.png",
        img: "./images/oweek/oweek-groups/Group 10_ Dino Quixote/Liora Ginsburg_Dino Quixote.JPG",
      },
      {
        name: "Logan Hobbs",
        email: "",
        major: "",
        collegetag: "./college-tags/jones_tag.png",
        img: "./images/oweek/oweek-groups/Group 10_ Dino Quixote/Logan Hobbs_Dino Quixote.JPG",
      },
      {
        name: "Shuken Nakamura",
        email: "",
        major: "",
        collegetag: "./college-tags/jones_tag.png",
        img: "./images/oweek/oweek-groups/Group 10_ Dino Quixote/Shuken Nakamura_Dino Quixote.JPG",
      },
    ],
  },
  {
    name: "TriceraTop Gun",
    members:
      "Brian Messar, Demitrius Chrysostomou, Sammy Gautham, Sanjana Katti, Tori Cole",
    img: "./images/oweek/oweek-groups/Group 11_ TriceraTop Gun/69.png",
    profiles: [
      {
        name: "Brian Messar",
        email: "",
        major: "",
        collegetag: "./college-tags/jones_tag.png",
        img: "./images/oweek/oweek-groups/Group 11_ TriceraTop Gun/Brian Messar_TriceraTop Gun.jpg",
      },
      {
        name: "Demitrius Chrysostomou",
        email: "",
        major: "",
        collegetag: "./college-tags/jones_tag.png",
        img: "./images/oweek/oweek-groups/Group 11_ TriceraTop Gun/Demitrius Chrysostomou_TriceraTop Gun.jpg",
      },
      {
        name: "Sammy Gautham",
        email: "",
        major: "",
        collegetag: "./college-tags/jones_tag.png",
        img: "./images/oweek/oweek-groups/Group 11_ TriceraTop Gun/Sammy Gautham_TriceraTop Gun.jpg",
      },
      {
        name: "Sanjana Katti",
        email: "",
        major: "",
        collegetag: "./college-tags/jones_tag.png",
        img: "./images/oweek/oweek-groups/Group 11_ TriceraTop Gun/Sanjana Katti_TriceraTop Gun.jpg",
      },
      {
        name: "Tori Cole",
        email: "",
        major: "",
        collegetag: "./college-tags/jones_tag.png",
        img: "./images/oweek/oweek-groups/Group 11_ TriceraTop Gun/Tori Cole_ TriceraTop Gun.jpg",
      },
    ],
  },
  {
    name: "Mission Infossible",
    members: "Angella Zhao, CJ Friend",
    img: "./images/oweek/oweek-groups/Group 12_ Mission Infossible/71.png",
    profiles: [
      {
        name: "Angella Zhao",
        email: "",
        major: "",
        collegetag: "./college-tags/jones_tag.png",
        img: "./images/oweek/oweek-groups/Group 12_ Mission Infossible/Angella Zhao_Mission Infossible.jpg",
      },
      {
        name: "CJ Friend",
        email: "",
        major: "",
        collegetag: "./college-tags/jones_tag.png",
        img: "./images/oweek/oweek-groups/Group 12_ Mission Infossible/CJ Friend_Mission Infossible.jpg",
      },
    ],
  },
];

export const PAAs = [
  {
    name: "JACKSON O'BRIAN",
    email: "jo60@rice.edu",
    major: "Mechanical Engineering",
    img: "./images/oweek/paas/jackson.png",
  },
  {
    name: "COLEMAN O'BRIAN",
    email: "co63@rice.edu",
    major: "Mechanical Engineering",
    img: "./images/oweek/paas/coleman.jpg",
  },
  {
    name: "SHIVANI PATEL",
    email: "sjp11@rice.edu",
    major: "Biology and Neuroscience",
    img: "./images/oweek/paas/shivani_p.png",
  },
  {
    name: "MAYA IYENGAR",
    email: "mi28@rice.edu",
    major: "Sports Management and SOPA",
    collegetag: "./college-tags/jones_tag.png",
    img: "./images/oweek/paas/maya_i.png",
  },
];

export const Gophers = [
  {
    name: "TBD",
    email: "--",
    major: "--",
    collegetag: "./college-tags/jones_tag.png",
    img: "./images/jones_logo_l.jpeg",
  },
];
